import React, { useState } from "react";
import { Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo, faTimes } from "@fortawesome/free-solid-svg-icons";
import "../../molecules/BrandModal.css";

export const ResubmitModal = ({ toggle, setToggle, onResubmit, accountId }) => {
  const [additional, setAdditional] = useState("");
  const [showAdditionalError, setShowAdditionalError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const close = () => {
    setToggle(false);
    setAdditional("");
    setShowAdditionalError(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!additional.trim()) {
      setShowAdditionalError(true);
      return;
    }
    setSubmitting(true);
    try {
      await onResubmit(accountId, additional);
      close();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen={toggle} toggle={close} className="brand-modal">
      <ModalHeader toggle={close}>Resubmit request</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">Please provide a justification for resubmitting this request to the requestor.</p>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="additionalEmail">Justification</Label>
            <Input
              type="textarea"
              id="additionalEmail"
              placeholder="Justification text that will be included in email"
              value={additional}
              onChange={(e) => {
                setAdditional(e.target.value);
                if (e.target.value.trim()) setShowAdditionalError(false);
              }}
            />
            {showAdditionalError && <p className="text-danger">Required</p>}
          </FormGroup>
          <div className="brand-modal__actions">
            <button type="submit" className="brand-modal__btn brand-modal__btn--primary" disabled={submitting}>
              <FontAwesomeIcon icon={faRedo} /> {submitting ? "Resubmitting…" : "Resubmit"}
            </button>
            <button type="button" className="brand-modal__btn brand-modal__btn--cancel" onClick={close} disabled={submitting}>
              <FontAwesomeIcon icon={faTimes} /> Cancel
            </button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};